import { render, staticRenderFns } from "./Fase4.vue?vue&type=template&id=085060a5&scoped=true"
import script from "./Fase4.vue?vue&type=script&lang=js"
export * from "./Fase4.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "085060a5",
  null
  
)

export default component.exports